import React from 'react'
import { Box, Center, Grid, Heading, Image, Link, Text } from '@chakra-ui/react'
import { ChevronRightIcon } from '@chakra-ui/icons'

export default function CategoriesOnFocus() {
    const categoriesOnFocus = [
        {
            id: 1,
            title: 'Diabetology',
            off: 'Up to 50% off'
        },
        {
            id: 2,
            title: 'Neurology',
            off: 'Up to 60% off'
        },
        {
            id: 3,
            title: 'Oncology',
            off: 'Up to 76% off'
        },
        {
            id: 4,
            title: 'Cardiology',
            off: 'Up to 83% off'
        },
        {
            id: 5,
            title: 'Respiratory',
            off: 'Up to 60% off'
        }
    ]
  return (
    <Box p='0 25px' mb='30px' display={{base: 'none', md: 'block'}}>
        <Box display={'flex'} alignItems='center' justifyContent='space-between' mb='30px'>
            <Box>
               <Heading as='h2' fontSize='25px' fontWeight='500'>Categories in Focus</Heading>
            </Box>
            <Box>
                <Link color='red' style={{textDecoration: 'none'}} ><Text>View All <ChevronRightIcon/></Text></Link>
            </Box>
        </Box>
        <Grid templateColumns={`repeat(${categoriesOnFocus.length},1fr)`} gap={3}>
            {
                categoriesOnFocus.map(((el, index) => (
                    <Box key={el.id} bg='#fff' p='30px 20px' borderRadius={6} boxShadow='md' cursor='pointer'>
                        <Center><Image h={'150px'}  objectFit="cover" margin={"0 auto"} src={process.env.PUBLIC_URL+`/Images/udyogCOF${index+1}.png`}></Image></Center>
                        <Center><Text mt='20px' fontWeight={'600'}>{el.title}</Text></Center>
                        <Center><Text mt='30px' color='#60a723' fontWeight={500} fontSize={'15px'}>{el.off}</Text></Center>
                    </Box>
                )))
            }
        </Grid>
    </Box>
  )
}
